import script from "./TimeSlots.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeSlots.vue?vue&type=script&setup=true&lang=js"

import "./TimeSlots.vue?vue&type=style&index=0&id=228d02bc&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228d02bc"]])

export default __exports__